import HelloSign from 'hellosign-embedded';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

const EmbedSignedDocumentPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const embedUrlParam = params.get('embedUrl');

  const clientId = import.meta.env.VITE_HELLO_SIGN_CLIENT_ID;

  useEffect(() => {
    if (clientId && embedUrlParam) {
      const client = new HelloSign();

      client.open(embedUrlParam, {
        clientId,
        skipDomainVerification: true
      });
    }
  }, [clientId, embedUrlParam]);

  return (
    <>
      <Helmet>
        <meta content="width=device-width, initial-scale=1.0, maximum-scale=1.0" name="viewport" />
      </Helmet>
      <p>
        <FormattedMessage id="models.signedDocument.closeBrowserWindow" />
      </p>
    </>
  );
};

export default EmbedSignedDocumentPage;
